import React, { useState, useEffect } from 'react';

import DefaultForm from 'components/form/DefaultForm';
import DefaultModal from 'components/modal/DefaultModal';
import { theme } from 'utils/style/theme';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import {
  showApiErrorMessage,
  showApiSuccessMessage,
} from 'utils/helper/message';
import PrimaryButton from 'components/button/PrimaryButton';
import { modelAPI } from 'apis/resource/modelAPI';
import InputStyled from 'components/InputStyled';
import {
  DefaultInputCountConfig,
  IModel,
  IModelSlave,
} from 'utils/types/storyTypes';
import { useParams } from 'react-router-dom';
import InputWithCounter from 'components/input/InputWithCounter';
/**
 * * 리소스 - 배경 수정 모달
 */

interface IProps {
  visible: boolean;
  setVisible: (e: any) => void;

  currentModel: IModel | null; // ModelSlave
  setCurrentModel: React.Dispatch<IModel | null>;

  currentSlave: IModelSlave | null;
  setCurrentSlave: React.Dispatch<IModelSlave | null>;
  setRefresh: React.Dispatch<React.SetStateAction<boolean>>;
  refresh: boolean;
}

const ModelMotionUpdateModal = ({
  visible,
  setVisible,
  currentModel,
  setCurrentModel,

  currentSlave,
  setCurrentSlave,
  setRefresh,
  refresh,
}: IProps) => {
  const { t } = useTranslation();
  const { projectId } = useParams(); // id: 프로젝트 id
  const [inputValue, setInputValue] = useState<null | string>(null);

  useEffect(() => {
    console.log(`ModelMotionUpdateModal : `, currentSlave);

    if (currentSlave) {
      setInputValue(currentSlave.motion_name);
    }
  }, [currentSlave]);

  const handleClose = () => {
    setVisible(false);
  };

  const [loading, setLoading] = useState<boolean>(false);

  /// 서버 전송
  const handleSubmit = async () => {
    if (currentSlave) {
      const postData = {
        model_slave_id: currentSlave.model_slave_id,
        motion_name: inputValue,
      };
      try {
        setLoading(true);

        await modelAPI.updateModelMotion(
          projectId,
          currentSlave.model_id,
          postData,
        );

        setRefresh(!refresh);
        setVisible(false);
        setLoading(false);

        showApiSuccessMessage('모션 이름이 적용되었습니다');

        if (currentSlave) {
          currentSlave.motion_name = inputValue ? inputValue : '';
          setCurrentSlave(currentSlave);
        }
      } catch (err) {
        console.log('update error', err);
        setLoading(false);
        showApiErrorMessage(err);
      }
    }
  };

  const handleInputChange = (e, type: string) => {
    setInputValue(e.target.value);
  };
  return (
    <DefaultModal
      title={t(
        'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.characterContent.updateAssetModal.title',
      )}
      visible={visible}
      onCancel={handleClose}
      footer={
        <ButtonWrapper>
          <PrimaryButton
            text={t('updateStory.form.buttonSubmit')}
            height='40px'
            width='fit-content'
            bgColor={theme.colors.blue_500}
            textColor='#ffffff'
            fontWeight={theme.fontWeights.medium}
            fontSize={theme.fontSizes.normal}
            border={`1px solid ${theme.colors.blue_500}`}
            rounded='6px'
            hoverBgColor={theme.colors.blue_600}
            activeBgColor={theme.colors.blue_800}
            selectedBgColor={theme.colors.blue_700}
            onClick={handleSubmit}
            loading={loading}
          />
        </ButtonWrapper>
      }
    >
      <DefaultForm>
        <FormWrapper>
          <HeaderWrapper>
            <p>ID: {currentSlave?.model_slave_id}</p>
          </HeaderWrapper>
          <div>
            <p className='title'>
              {t(
                'storyEpisodeID.storyTabMenuList.resourceContent.resourceTabMenuList.characterContent.updateAssetModal.form.motionName',
              )}
            </p>
            <InputWithCounter
              value={inputValue ? inputValue : ''}
              onChange={(e) => {
                handleInputChange(e, 'motion_name');
              }}
              maxLength={30}
              placeholder='캐릭터 모션 이름을 등록합니다. (EX : 캐릭터이름_당황)'
              count={DefaultInputCountConfig}
            />
          </div>
        </FormWrapper>
      </DefaultForm>
    </DefaultModal>
  );
};

export default ModelMotionUpdateModal;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  p {
    color: ${theme.colors.dark_500};
    font-weight: ${theme.fontWeights.bold};
    font-size: ${theme.fontSizes.md};
  }
`;

const FormWrapper = styled.div`
  & > * + * {
    margin-top: 16px;
  }
  .title,
  .length-subtext {
    font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
  }
  .length-subtext {
    margin-top: 8px !important;
    font-size: ${theme.fontSizes.normal};
    font-style: normal;
    font-weight: ${theme.fontWeights.normal};
    line-height: 20px;
    letter-spacing: 0.2px;
    color: ${theme.colors.dark_200};
  }
  .ant-input-show-count-suffix {
    display: none;
  }
  .remove {
    display: flex;
    justify-content: end;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
`;
